module.exports = __webpack_public_path__ + "img/16.d5b31821.png";